import React, { createContext, useState, useContext } from 'react';
import { track } from '../analytics/analytics';

const RecentlyAddedCompaniesContext = createContext();

export const useRecentlyAddedCompanies = () => useContext(RecentlyAddedCompaniesContext);

export const RecentlyAddedCompaniesProvider = ({ children }) => {
  const [recentlyAddedCompanies, setRecentlyAddedCompanies] = useState([]);

  const addRecentlyAddedCompany = (company) => {
    // Every successful company add funnels through here — record it on the user's
    // journey so "who added <company>" is answerable in Product Analytics.
    track('add_company', {
      companyId: company?.companyId || null,
      companyName: company?.companyName || null,
      segment: company?.segment?.name || company?.segment?.id || null,
    });
    setRecentlyAddedCompanies((prev) => [...prev, company]);
  };

  const clearRecentlyAddedCompanies = () => {
    setRecentlyAddedCompanies([]);
  };

  return (
    <RecentlyAddedCompaniesContext.Provider value={{ recentlyAddedCompanies, addRecentlyAddedCompany, clearRecentlyAddedCompanies }}>
      {children}
    </RecentlyAddedCompaniesContext.Provider>
  );
};
